import React, { useState } from 'react';
import useDms from '../../hooks/useDms';
import { Loading, ErrorBox, Empty } from './shared';
import ShowDetail from './ShowDetail';

export default function ReportsShows() {
  const { data, loading, error } = useDms('shows');
  const [selected, setSelected] = useState(null);

  if (loading) return <Loading label="Loading show records…" />;
  if (error) return <ErrorBox error={error} />;

  if (selected) return <ShowDetail name={selected.slug || selected.artist} onBack={() => setSelected(null)} />;

  const shows = data?.data || [];

  return (
    <div className="lyve-intel">
      <div className="hero" style={{ paddingBottom: 0 }}>
        <div className="eyebrow">
          <i />
          REPORTS · SHOWS
        </div>
        <h1 className="h-title wide">SHOWS</h1>
        <p className="h-sub">
          Structured Lyve DMS show records (lyve.dms.show_record v1.0) with section inventory and live SeatData
          resale-market data.
        </p>
      </div>

      <div className="page" style={{ paddingTop: 18 }}>
        {shows.length === 0 && <Empty label="No show records yet." />}
        <div className="rp-grid rp-cols-3">
          {shows.map((s) => (
            <div
              className="rp-card rshow"
              key={s.slug || s.artist}
              onClick={() => setSelected(s)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && setSelected(s)}>
              <div className="when">{s.event_date}</div>
              <h3>{s.artist}</h3>
              <div className="venue">{s.tour}</div>
              <div className="venue">
                {s.venue}, {s.city}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
